export const initializeMicrosoftOAuth = () => {
  const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
  const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID || 'common';
  const redirectUri = encodeURIComponent(`${window.location.origin}/auth/microsoft/callback`);
  const scope = encodeURIComponent('openid email profile User.Read');
  const responseType = 'code';

  const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&scope=${scope}&response_mode=query`;

  return authUrl;
};
